import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          HOPTHU.ME
        </p>
      </header>
    </div>
  );
}

export default App;
